import React from "react";
import { View } from "react-native";
import { VH, VW } from "../../constants/size";

export const Row: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <View
      style={{
        width: VW,
        height: VH,
        padding: 12,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
      }}
    >
      {children}
    </View>
  );
};

export const Column: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <View
      style={{
        flex: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </View>
  );
};

export const Spacer = () => {
  return (
    <View
      style={{
        height: 48,
      }}
    />
  );
};
